import React, { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Sparkles, ArrowRight } from "lucide-react";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [passkey, setPasskey] = useState("admin123");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    
    const res = await login(passkey);
    setLoading(false);
    
    if (res.ok) {
      navigate("/");
    } else {
      setError(res.error || "Login failed");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-900">
      <div className="w-full max-w-md p-8">
        <div className="text-center mb-8">
          <div className="h-16 w-16 bg-white rounded-2xl flex items-center justify-center mx-auto mb-4">
            <Sparkles className="h-8 w-8 text-slate-900" />
          </div>
          <h1 className="text-3xl font-bold text-white">Welcome</h1>
          <p className="text-slate-400 mt-2">Enter passkey to continue</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label className="text-slate-300 text-sm">Passkey</Label>
            <Input
              type="password"
              value={passkey}
              onChange={(e) => setPasskey(e.target.value)}
              className="bg-slate-800 border-slate-700 text-white mt-1"
              placeholder="Enter passkey"
            />
          </div>

          {error && (
            <div className="text-red-400 text-sm">{error}</div>
          )}

          <Button type="submit" disabled={loading} className="w-full bg-white text-slate-900 hover:bg-slate-100">
            {loading ? "Signing in..." : "Sign in"}
          </Button>
        </form>

        <div className="mt-8 p-4 bg-slate-800 rounded-lg text-center">
          <p className="text-slate-400 text-sm">Passkey: admin123</p>
        </div>
      </div>
    </div>
  );
}